import { render } from "./FacebookLoginDialog.vue?vue&type=template&id=23ea2a46"
import script from "./FacebookLoginDialog.vue?vue&type=script&lang=js"
export * from "./FacebookLoginDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__